import styled, { keyframes } from 'styled-components';

const COLORS = {
  darkGrey: '#858585',
  disabledGrey: '#E0E0E0',
  buttonGreen: '#009688',
  buttonHoverGreen: '#01BEA4',
  lightGrey: '#616161',
  overlayDark: '#33333322',
  panelShadow: '#0000004D',
  primaryGreen: '#009688',
  white: '#ffffff',
};

const animationIn = keyframes`
  0% { 
    left: 50px;
    opacity: 0; 
  }
  
  100% { 
    left: 0; 
    opacity: 1; 
  }
`;

const ProposalCreated = styled.div`
  * {
    font-family: 'Montserrat';
    margin: 0;
    padding: 0;
  }

  animation: ${animationIn} 0.5s forwards;
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 10px;
  justify-content: center;
  width: 45em;
  height: 100%;
  margin: auto;
  position: relative;
`;

const Title = styled.h1`
  font-size: 2.2em;
  width: 100%;
`;

const Description = styled.p`
  color: #0000008a;
  font-size: 1rem;
  font-weight: 400;
  padding: 0.5em 0;
  text-align: left;
  width: 100%;
`;

const ActionWrapper = styled.div`
  margin-top: 2em;
  width: 100%;
`;

const Spacer = styled.div`
  position: relative;
  text-align: center;
  margin: 1em 0;

  span {
    background-color: #ffffff;
    padding: 1em;
    text-transform: uppercase;
    display: inline-block;
    text-align: center;
    position: relative;
    z-index: 1;
  }

  &:after {
    content: '';
    border-bottom: 1px solid #0000008a;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`;

const Button = styled.button`
  background-color: #009688;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-size: 1.5em;
  font-weight: 600;
  padding: 15px 0;
  transition: background-color 0.15s ease-in-out;
  width: 100%;

  &:hover {
    background-color: ${COLORS.buttonHoverGreen};
    border-color: ${COLORS.buttonHoverGreen};
  }
`;

const TransferInfoBlock = styled.div`
  text-align: left;
  background-color: #f2f2f2;
  border-radius: 3px;
  padding: 15px;
  font-size: 14px;
  width: 100%;
  margin: 5px 0;

  span {
    display: block;
    margin: 3px 0;
  }
`;

export {
  ProposalCreated,
  Title,
  Description,
  ActionWrapper,
  Button,
  Spacer,
  TransferInfoBlock,
};
